// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remainder-table{
    margin-top: 20px;
    max-height: calc(100vh - 380px); /* Set a max height to enable scrolling */
    overflow-y: scroll; 
    /* padding:0px 20px; */
 }
 
 .remainder-table::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .remainder-table::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

 .remainder-table-head{
    display: grid;
    grid-template-columns: repeat(15, minmax(0, 1fr));
    text-align: center;
    background-color: #0059B2;
    color: #FFFFFF;
    padding: 20px 10px;
    border-radius: 10px;
    position: sticky;
  top: 0;
  z-index: 1;

 }
 .remainder-message{
    grid-column: span 6;
 }
 .remainder-table-head>div:nth-child(2){
    grid-column: span 2;
    text-align: center;
 }
 .remainder-table-head>div:nth-child(5){
    grid-column: span 2;
    text-align: center;
 }


 .remainder-table-body{
    display: grid;
    grid-template-columns: repeat(15, minmax(0, 1fr));
    text-align: center;
    padding: 20px 10px;
    border-radius: 25px;
    margin: 20px 10px;
    border: 1px solid lightgray;
    font-size:13px;
    align-items: center;
    justify-content: center;
 }


 .remainder-table-body>div:nth-child(2){
    grid-column: span 2;
    text-align: center;
 }
 .remainder-table-body>div:nth-child(5){
    grid-column: span 2;
    text-align: center;
 }

 .remainder-table-body>div{
   padding: 0px 10px;
 }

 .remainder-table-body:hover{
    transform: scale(1.01);
 }


 .popUptab{
  display: flex;
   margin-top: 30px;
   justify-content: center;
   
 }

 .popUptab>div{
   margin-right: 50px;
 }




 .remainder-bulk-table{
   margin-top: 20px;
   max-height: calc(100vh - 200px); /* Set a max height to enable scrolling */
   overflow-y: scroll; 
   padding:0px 20px;
}

.remainder-bulk-table::-webkit-scrollbar {
   width: 0; /* Set the width of the scrollbar to a minimal value */
 }
 
 .remainder-bulk-table::-webkit-scrollbar-thumb {
   background: none; /* Set the scrollbar thumb to be transparent */
 }

.remainder-bulk-table-head{
   display: grid;
   grid-template-columns: repeat(16, minmax(0, 1fr));
   text-align: center;
   background-color: #0059B2;
   color: #FFFFFF;
   padding: 20px 10px;
   border-radius: 10px;
   position: sticky;
 top: 0;
 z-index: 1;

}
.remainder-bulk-message{
   grid-column: span 8;
}
.remainder-bulk-table-head>div:nth-child(3){
   grid-column: span 4;
   text-align: center;
}



.remainder-bulk-table-body{
   display: grid;
   grid-template-columns: repeat(16, minmax(0, 1fr));
   text-align: center;
   padding: 20px 10px;
   border-radius: 25px;
   margin: 20px 0px;
   border: 1px solid lightgray;
   font-size:13px;
   align-items: center;
   justify-content: center;
}


.remainder-bulk-table-body>div:nth-child(3){
   grid-column: span 4;
   text-align: center;
}


.remainder-bulk-table-body>div{
  padding: 0px 10px;
}

.remainder-bulk-table-body:hover{
   transform: scale(1.01);
}

/* Email Notification Table Styles */
.email-notification-table {
   margin-top: 20px;
   max-height: calc(100vh - 300px);
   overflow-y: scroll;
}

.email-notification-table::-webkit-scrollbar {
   width: 0;
}

.email-notification-table::-webkit-scrollbar-thumb {
   background: none;
}

.email-notification-table-head {
   display: grid;
   grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;  /* 9 columns now */
   text-align: center;
   background-color: #0059B2;
   color: #FFFFFF;
   padding: 10px 10px;
   border-radius: 10px;
   position: sticky;
   top: 0;
   z-index: 1;
}

.email-notification-table-body {
   display: grid;
   grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;  /* 9 columns now */
   text-align: center;
   padding: 5px 10px;
   margin: 1px 10px;
   border: 1px solid lightgray;
   border-radius: 25px;
   font-size: 13px;
   align-items: center;
   justify-content: center;
}

.email-notification-table-body > div {
   padding: 0px 10px;
}

.email-notification-table-body:hover {
   transform: scale(1.01);
}

/* Due Popup Table Styles */
.due-popup-table {
    margin-top: 10px;
}

.due-popup-table-head {
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: center;
    background-color: #0059B2;
    color: #FFFFFF;
    padding: 15px 10px;
    border-radius: 10px;
    font-weight: 500;
}

.due-popup-table-body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: center;
    padding: 12px 10px;
    border-bottom: 1px solid lightgray;
    font-size: 13px;
}

.due-popup-table-body:hover {
    background-color: #f5f5f5;
}

.due-popup-total {
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: center;
    padding: 15px 10px;
    background-color: #e8f4fd;
    border-radius: 10px;
    margin-top: 10px;
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/HospitalNotices/HospitalRemainder.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+BAA+B,EAAE,yCAAyC;IAC1E,kBAAkB;IAClB,sBAAsB;CACzB;;CAEA;IACG,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;CAED;IACG,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB,MAAM;EACN,UAAU;;CAEX;CACA;IACG,mBAAmB;CACtB;CACA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;CACA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;;;CAGA;IACG,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;IAId,mBAAmB;IACnB,uBAAuB;CAJ1B;;;CAQA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;CACA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;;CAEA;GACE,iBAAiB;CACnB;;CAEA;IACG,sBAAsB;CACzB;;;CAGA;EACC,aAAa;GACZ,gBAAgB;GAChB,uBAAuB;;CAEzB;;CAEA;GACE,kBAAkB;CACpB;;;;;CAKA;GACE,gBAAgB;GAChB,+BAA+B,EAAE,yCAAyC;GAC1E,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,QAAQ,EAAE,sDAAsD;CAClE;;CAEA;GACE,gBAAgB,EAAE,8CAA8C;CAClE;;AAED;GACG,aAAa;GACb,iDAAiD;GACjD,kBAAkB;GAClB,yBAAyB;GACzB,cAAc;GACd,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;CAClB,MAAM;CACN,UAAU;;AAEX;AACA;GACG,mBAAmB;AACtB;AACA;GACG,mBAAmB;GACnB,kBAAkB;AACrB;;;;AAIA;GACG,aAAa;GACb,iDAAiD;GACjD,kBAAkB;GAClB,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;GAChB,2BAA2B;GAC3B,cAAc;GAId,mBAAmB;GACnB,uBAAuB;AAJ1B;;;AAQA;GACG,mBAAmB;GACnB,kBAAkB;AACrB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;GACG,sBAAsB;AACzB;;AAEA,oCAAoC;AACpC;GACG,gBAAgB;GAChB,+BAA+B;GAC/B,kBAAkB;AACrB;;AAEA;GACG,QAAQ;AACX;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,0DAA0D,GAAG,kBAAkB;GAC/E,kBAAkB;GAClB,yBAAyB;GACzB,cAAc;GACd,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;GAChB,MAAM;GACN,UAAU;AACb;;AAEA;GACG,aAAa;GACb,0DAA0D,GAAG,kBAAkB;GAC/E,kBAAkB;GAClB,iBAAiB;GACjB,gBAAgB;GAChB,2BAA2B;GAC3B,mBAAmB;GACnB,eAAe;GACf,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".remainder-table{\n    margin-top: 20px;\n    max-height: calc(100vh - 380px); /* Set a max height to enable scrolling */\n    overflow-y: scroll; \n    /* padding:0px 20px; */\n }\n \n .remainder-table::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .remainder-table::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n .remainder-table-head{\n    display: grid;\n    grid-template-columns: repeat(15, minmax(0, 1fr));\n    text-align: center;\n    background-color: #0059B2;\n    color: #FFFFFF;\n    padding: 20px 10px;\n    border-radius: 10px;\n    position: sticky;\n  top: 0;\n  z-index: 1;\n\n }\n .remainder-message{\n    grid-column: span 6;\n }\n .remainder-table-head>div:nth-child(2){\n    grid-column: span 2;\n    text-align: center;\n }\n .remainder-table-head>div:nth-child(5){\n    grid-column: span 2;\n    text-align: center;\n }\n\n\n .remainder-table-body{\n    display: grid;\n    grid-template-columns: repeat(15, minmax(0, 1fr));\n    text-align: center;\n    padding: 20px 10px;\n    border-radius: 25px;\n    margin: 20px 10px;\n    border: 1px solid lightgray;\n    font-size:13px;\n }\n\n .remainder-table-body{\n    align-items: center;\n    justify-content: center;\n }\n\n\n .remainder-table-body>div:nth-child(2){\n    grid-column: span 2;\n    text-align: center;\n }\n .remainder-table-body>div:nth-child(5){\n    grid-column: span 2;\n    text-align: center;\n }\n\n .remainder-table-body>div{\n   padding: 0px 10px;\n }\n\n .remainder-table-body:hover{\n    transform: scale(1.01);\n }\n\n\n .popUptab{\n  display: flex;\n   margin-top: 30px;\n   justify-content: center;\n   \n }\n\n .popUptab>div{\n   margin-right: 50px;\n }\n\n\n\n\n .remainder-bulk-table{\n   margin-top: 20px;\n   max-height: calc(100vh - 200px); /* Set a max height to enable scrolling */\n   overflow-y: scroll; \n   padding:0px 20px;\n}\n\n.remainder-bulk-table::-webkit-scrollbar {\n   width: 0; /* Set the width of the scrollbar to a minimal value */\n }\n \n .remainder-bulk-table::-webkit-scrollbar-thumb {\n   background: none; /* Set the scrollbar thumb to be transparent */\n }\n\n.remainder-bulk-table-head{\n   display: grid;\n   grid-template-columns: repeat(16, minmax(0, 1fr));\n   text-align: center;\n   background-color: #0059B2;\n   color: #FFFFFF;\n   padding: 20px 10px;\n   border-radius: 10px;\n   position: sticky;\n top: 0;\n z-index: 1;\n\n}\n.remainder-bulk-message{\n   grid-column: span 8;\n}\n.remainder-bulk-table-head>div:nth-child(3){\n   grid-column: span 4;\n   text-align: center;\n}\n\n\n\n.remainder-bulk-table-body{\n   display: grid;\n   grid-template-columns: repeat(16, minmax(0, 1fr));\n   text-align: center;\n   padding: 20px 10px;\n   border-radius: 25px;\n   margin: 20px 0px;\n   border: 1px solid lightgray;\n   font-size:13px;\n}\n\n.remainder-bulk-table-body{\n   align-items: center;\n   justify-content: center;\n}\n\n\n.remainder-bulk-table-body>div:nth-child(3){\n   grid-column: span 4;\n   text-align: center;\n}\n\n\n.remainder-bulk-table-body>div{\n  padding: 0px 10px;\n}\n\n.remainder-bulk-table-body:hover{\n   transform: scale(1.01);\n}\n\n/* Email Notification Table Styles */\n.email-notification-table {\n   margin-top: 20px;\n   max-height: calc(100vh - 300px);\n   overflow-y: scroll;\n}\n\n.email-notification-table::-webkit-scrollbar {\n   width: 0;\n}\n\n.email-notification-table::-webkit-scrollbar-thumb {\n   background: none;\n}\n\n.email-notification-table-head {\n   display: grid;\n   grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;  /* 9 columns now */\n   text-align: center;\n   background-color: #0059B2;\n   color: #FFFFFF;\n   padding: 10px 10px;\n   border-radius: 10px;\n   position: sticky;\n   top: 0;\n   z-index: 1;\n}\n\n.email-notification-table-body {\n   display: grid;\n   grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;  /* 9 columns now */\n   text-align: center;\n   padding: 5px 10px;\n   margin: 1px 10px;\n   border: 1px solid lightgray;\n   border-radius: 25px;\n   font-size: 13px;\n   align-items: center;\n   justify-content: center;\n}\n\n.email-notification-table-body > div {\n   padding: 0px 10px;\n}\n\n.email-notification-table-body:hover {\n   transform: scale(1.01);\n}\n\n/* Due Popup Table Styles */\n.due-popup-table {\n    margin-top: 10px;\n}\n\n.due-popup-table-head {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    text-align: center;\n    background-color: #0059B2;\n    color: #FFFFFF;\n    padding: 15px 10px;\n    border-radius: 10px;\n    font-weight: 500;\n}\n\n.due-popup-table-body {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    text-align: center;\n    padding: 12px 10px;\n    border-bottom: 1px solid lightgray;\n    font-size: 13px;\n}\n\n.due-popup-table-body:hover {\n    background-color: #f5f5f5;\n}\n\n.due-popup-total {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    text-align: center;\n    padding: 15px 10px;\n    background-color: #e8f4fd;\n    border-radius: 10px;\n    margin-top: 10px;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
